import React from 'react';
import pt from 'prop-types';
import {withRouter} from 'react-router';
import getRoutes from './routes/routes';
import EpicGamesNavWrapper from './components/nav/EpicGamesNavWrapper';
import Footer from './components/footer/Footer';
import styled from 'styled-components';
import {UeThemeProvider} from 'epic-ue-components';
import Immutable from 'seamless-immutable';
import {StoreProvider} from './stores';
import bingSearchColors from 'epic-react-search/app/scripts/theme/colors';

const theme = {
    colors: {
        white: '#fff'
    },
    bingSearch: bingSearchColors,
    placeholder: {
        color: '#cdcdcd',
        animation: 'react-placeholder-pulse 1.5s infinite'
    },
    fonts: {
        brutal: {
            bold: 'Brutal_Bold',
            medium: 'Brutal_Medium',
            regular: 'Brutal_Regular',
            light: 'Brutal_Light'
        }
    }
};

const AppContainer = styled.div`
    min-height: 50vh;
    background: #1d1d1d;
`;

const AppContent = styled.div`
    min-height: 50vh;
`;

class App extends React.Component {
    static propTypes = {
        appState: pt.object
    };

    render() {
        const routes = getRoutes();
        const appState = this.props.appState || {};
        const epicGamesHeader = appState.epicGamesHeader || {};
        const headerStore = Immutable({config: epicGamesHeader});
        const epicGamesFooter = appState.epicGamesFooter || {};
        const footerStore = Immutable({config: epicGamesFooter});

        return (
            <UeThemeProvider theme={theme}>
                <StoreProvider initialValue={appState}>
                    <AppContainer>
                        <EpicGamesNavWrapper headerStore={headerStore} {...this.props} />
                        <AppContent>{routes}</AppContent>
                        <Footer footerStore={footerStore} {...this.props} />
                    </AppContainer>
                </StoreProvider>
            </UeThemeProvider>
        );
    }
}

export default withRouter(App);
